import {GET_PROFIT, GET_PROFIT_DONE, SET_PROFIT_TIME_FROM_MAX, SET_PROFIT_TIME_TO_MAX} from '../types';
import {SET_PROFIT_TIME_FROM} from '../types';
import {SET_PROFIT_TIME_TO} from '../types';
import {dataMonthInterval, timeTo} from "../../utils/timeInterval";

const initialState = {
    items: {
        daily: [],
        monthly: [],
        investment: [],
        total: [],
    },
    profitTimeFrom: null,
    profitTimeTo: null,
    profitTimeFromMax: +new Date(new Date().setMonth(timeTo.getMonth() - 24)),
    profitTimeToMax: +new Date(),
    getProfitDone: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PROFIT:
            return {
                ...state, items: action.payload,

            };
        case GET_PROFIT_DONE:
            return {
                ...state, getProfitDone: action.payload,

            };
        case SET_PROFIT_TIME_FROM:
            return {
                ...state, profitTimeFrom: action.payload,
            };
        case SET_PROFIT_TIME_TO:
            return {
                ...state, profitTimeTo: action.payload,
            };
        case SET_PROFIT_TIME_FROM_MAX:
            return {
                ...state, profitTimeFromMax: action.payload,
            };
        case SET_PROFIT_TIME_TO_MAX:
            return {
                ...state, profitTimeToMax: action.payload,
            };
        default:
            return state;
    }

}
